import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {

  private deploymentData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  deploymentData$: Observable<any> = this.deploymentData.asObservable();
  private userId;

  constructor(@Inject('apiEndPoint') private apiEndPoint: string, private httpClient: HttpClient) { }

  setDeploymentData(newData) {
    this.deploymentData.next(newData);
  }

  getDivecename(): Observable<any> {
    // let headers = new HttpHeaders();
    return this.httpClient.get(this.apiEndPoint + '/_/2.0/devicelist')
  }

//   set userToEdit(userId) {
//     this.userId = userId;
//   }

//   get userToEdit() {
//     return this.userId;
//   }

}